/**
 * Keep a single semantic H1 per page while preserving visual styles on demoted headings.
 * Handles third-party widgets (e.g. Recharge) that inject extra H1 elements after load.
 */
(function () {
  'use strict';

  function replaceTag(el, tagName) {
    if (!el || el.tagName.toLowerCase() === tagName) return el;

    var replacement = document.createElement(tagName);

    replacement.className = el.className;
    replacement.innerHTML = el.innerHTML;

    Array.prototype.forEach.call(el.attributes, function (attr) {
      if (attr.name === 'class') return;
      replacement.setAttribute(attr.name, attr.value);
    });

    el.replaceWith(replacement);
    return replacement;
  }

  function primaryH1Selector() {
    if (document.body.classList.contains('template-index')) {
      return 'main .hz__bannerContent__title';
    }

    if (document.body.classList.contains('template-product')) {
      return 'main .wt-product__name';
    }

    return 'main h1';
  }

  function normalizeHeadings() {
    var primary = document.querySelector(primaryH1Selector());

    document.querySelectorAll('h1').forEach(function (heading) {
      if (heading === primary) return;
      replaceTag(heading, 'h2');
    });
  }

  var scheduled = false;

  function scheduleNormalize() {
    if (scheduled) return;
    scheduled = true;

    window.requestAnimationFrame(function () {
      scheduled = false;
      normalizeHeadings();
    });
  }

  function init() {
    normalizeHeadings();

    var observer = new MutationObserver(function () {
      scheduleNormalize();
    });

    observer.observe(document.body, { childList: true, subtree: true });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
